import { EXPIRY_TYPES, SYMBOL_TYPES } from '@fnx/fx-pad';
import { IAppBrandingConfig } from '../interfaces';

export const DATA: IAppBrandingConfig = {
    title: 'Finastra Seamless FX Web',
    favicon: '/assets/icon/favicon.ico',
    logo: '/assets/img/sfx-web-logo.svg',
    cover: '/assets/img/login-sample-00.png',
    websiteName: 'Finastra.com',
    websiteUrl: 'https://www.finastra.com',
    support: {
        phone: '+41 22 552 69 79',
        email: 'sfx-support@finastra.com',
        website: 'https://www.finastra.com/contact/sales',
    },
    color: {
        primary: 'var(--alk-v-100)',
        primaryVariantAlpha: 'var(--alk-v-75)',
        primaryVariantBeta: 'var(--alk-v-25)',
        primaryVariantGamma: 'var(--alk-v-10)',
        primaryVariantDelta: 'var(--alk-v-50)',
        secondary: 'var(--alk-f-100)',
        secondaryVariantAlpha: 'var(--alk-f-25)',
        secondaryVariantBeta: 'var(--alk-f-10)',
        informative: 'var(--alk-c-100)',
        processing: 'var(--alk-f-100)',
        success: 'var(--alk-success)',
        warning: 'var(--alk-warning)',
        error: 'var(--alk-error)',
        sell: 'var(--alk-r-100)',
        buy: 'var(--alk-g-100-dark)',
        backgroundVariantAlpha: 'var(--ag-grid-light)',
        userIconBackground: [
            'linear-gradient(0deg,',
            '#E40046 0%,',
            '#E95247 10%,',
            '#C137A2 30%,',
            '#9243BE 65.94%,',
            '#694ED6 100%,',
            '#FFFFFF 100%,',
            '#D882C5 100%)',
        ].join(' '),
        gridRowHighlight: '#8F7BE126',
        gridCellHighlight: '#8F7BE151',
        gridCellRangeHighlight: '#8F7BE113',
        tradingToggleBackgroundColor: 'var(--alk-r-75)',
    },
    tradingPad: {
        forward: {
            displayMode: 'default',
        },
        isSimplifiedQuoteHeader: false,
        productTypes: SYMBOL_TYPES,
        expiryTypes: EXPIRY_TYPES,
        pendingPriceTypes: [ 'limit', 'stop' ],
    },
    clickTradingMode: 'clickAndConfirm',
    notification: {
        audio: '/assets/audio/alert-quick-chime.wav',
    },
};

export const DATA_SAMPLE_02: IAppBrandingConfig = {
    title: 'FBII Web',
    favicon: '/assets/icon/favicon-sample-02.ico',
    logo: '/assets/img/logo-sample-02.svg',
    cover: '/assets/img/login-sample-00.png',
    websiteName: 'Fibi.co.il',
    websiteUrl: 'https://online.fibi.co.il',
    support: {
        phone: '+972 (0) 3-5130003',
        email: 'support@fibi.co.il',
        website: 'https://online.fibi.co.il',
    },
    color: {
        primary: '#0D67B6',
        primaryVariantAlpha: '#6EA4D3',
        primaryVariantBeta: '#B6D1E9',
        primaryVariantGamma: '#E7F0F8',
        primaryVariantDelta: '#0A5292',
        secondary: '#FBC100',
        secondaryVariantAlpha: '#B6D1E9',
        secondaryVariantBeta: '#FDE080',
        informative: 'var(--alk-c-100)',
        processing: 'var(--alk-f-100)',
        success: '#3C874E',
        warning: 'var(--alk-warning)',
        error: 'var(--alk-error)',
        sell: 'var(--alk-r-100)',
        buy: 'var(--alk-g-100-dark)',
        backgroundVariantAlpha: 'var(--ag-grid-light)',
        inputBackgroundColor: 'transparent',
        inputBackgroundColorFocus: 'transparent',
        userIconBackground: [
            'linear-gradient(0deg,',
            '#FBC100 0%,',
            '#EBD580 29.91%,',
            '#EBD580 30%,',
            '#89AED0 65.94%,',
            '#0B66D8 100%,',
            '#FFFFFF 100%,',
            '#D882C5 100%)',
        ].join(' '),
        gridRowHighlight: '#6EA4D326',
        gridCellHighlight: '#6EA4D351',
        gridCellRangeHighlight: '#6EA4D313',
        tradingToggleBackgroundColor: 'var(--alk-r-75)',
    },
    tradingPad: {
        forward: {
            displayMode: 'spot',
        },
        isSimplifiedQuoteHeader: false,
        productTypes: SYMBOL_TYPES,
        expiryTypes: EXPIRY_TYPES,
        pendingPriceTypes: [ 'limit', 'stop' ],
        isCrossedDisplay: true,
    },
    clickTradingMode: 'singleClick',
    isAmendPendingDisabled: false,
};

export const DATA_SAMPLE_01: IAppBrandingConfig = {
    title: 'GEBC Web',
    favicon: '/assets/icon/favicon-sample-01.ico',
    logo: '/assets/img/logo-sample-01.svg',
    cover: '/assets/img/login-sample-00.png',
    websiteName: 'Bcge.ch',
    websiteUrl: 'https://www.bcge.ch',
    support: {
        phone: '058 211 21 00',
        email: 'ForXchange@bcge.ch',
        website: 'https://www.bcge.ch',
    },
    color: {
        primary: '#EF3340',
        primaryVariantAlpha: '#F27282',
        primaryVariantBeta: '#F799A0',
        primaryVariantGamma: '#FDE8EA',
        primaryVariantDelta: '#BA1026',
        secondary: '#414141',
        secondaryVariantAlpha: '#CECECE',
        secondaryVariantBeta: '#FBB9C1',
        informative: 'var(--alk-c-100)',
        processing: '#f5a604',
        success: '#15CB89',
        warning: 'var(--alk-warning)',
        error: 'var(--alk-error)',
        sell: '#EF3340',
        buy: '#15CB89',
        backgroundVariantAlpha: 'var(--ag-grid-light)',
        inputBackgroundColor: 'transparent',
        inputBackgroundColorFocus: 'transparent',
        inputBottomBorderFocus: '#414141',
        userIconBackground: [
            'linear-gradient(0deg,',
            '#D882C5 0%,',
            '#FFFFFF 0%,',
            '#1C1819 0%,',
            '#6D6C6C 34.06%,',
            '#F48997 70%,',
            '#EF3334 100%)',
        ].join(' '),
        gridRowHighlight: '#F2728226',
        gridCellHighlight: '#F2728251',
        gridCellRangeHighlight: '#F2728213',
        tradingToggleBackgroundColor: '#EF3340',
    },
    tradingPad: {
        forward: {
            displayMode: 'simplified',
        },
        isSimplifiedQuoteHeader: true,
        productTypes: SYMBOL_TYPES,
        expiryTypes: EXPIRY_TYPES,
        pendingPriceTypes: [ 'limit', 'stop' ],
        isSimplifiedSwapView: true,
        isSimplifiedConfirmationStep: true,
    },
    clickTradingMode: 'clickAndConfirm',
    isAmendPendingDisabled: true,
    isSpeedBumpDisplay: true,
};
